import React from 'react'
import Templates from '../components/Templates/Templates'
import Navbar from '../components/Navbar/Navbar'

const Template = () => {
  return (
    <>
      <Navbar />
      <Templates />
    </>
  )
}

export default Template